import React, { useEffect, useRef } from "react";
import styles from "./dashboard.module.scss";
import Carousel from "react-elastic-carousel";
import Product from "../../components/product/Product";
import Title from "../../components/title/Title";

const ProdDivDashboard = (props) => {
  const {data,selectedRegion} = props;
  const myPDCarousel = useRef(null);

  const showHideLeftPDArrow = () => {
    // document.querySelector("#prodDivContainer #prodScrollToEnd").style.display = "none";
    if (document.querySelector("#prodDivContainer .rec.rec-arrow-left")) {
      // document.querySelector("#prodDivContainer #prodScrollToEnd").style.display = "none";
      if (document.querySelector("#prodDivContainer .rec.rec-arrow-left").disabled) {
        document.querySelector("#prodDivContainer #prodScrollToEnd").style.display = "block";
      }
      else {
        document.querySelector("#prodDivContainer #prodScrollToEnd").style.display = "none";
      }
    }
  }

  const showHideRightPDArrow = () => {
    document.querySelector("#prodDivContainer #prodScrollToStart").style.display = "none";
    if (document.querySelector("#prodDivContainer .rec.rec-arrow-right")) {
      document.querySelector("#prodDivContainer #prodScrollToStart").style.display = "none";
      if (document.querySelector("#prodDivContainer .rec.rec-arrow-right").disabled) {
        document.querySelector("#prodDivContainer #prodScrollToStart").style.display = "block";
      }
      else {
        document.querySelector("#prodDivContainer #prodScrollToStart").style.display = "none";
      }
    }
  }

  const myPDCarouselChange = (current, pagenum) => {
    showHideLeftPDArrow();
    showHideRightPDArrow();
  }

  const onClickPDScrollToStart = () => {/*Right PD Arrow- which takes to beginning */
    document.querySelector("#prodDivContainer #prodScrollToStart").style.display = "none";
    myPDCarousel?.current?.goTo(0);
  }

  const onClickPDScrollToEnd = () => {/*Left PD Arrow- which takes to dead end */
    document.querySelector("#prodDivContainer #prodScrollToEnd").style.display = "none";
    myPDCarousel?.current?.goTo(data.productDivisions.length);
  }

  useEffect(()=>{
    document.querySelector("#prodDivContainer #prodScrollToEnd").style.display = "block";
    document.querySelector("#prodDivContainer #prodScrollToStart").style.display = "none";
    myPDCarousel?.current?.goTo(0);  
    
  },[selectedRegion]);

  useEffect(()=>{
    document.querySelector("#prodDivContainer #prodScrollToEnd").style.display = "block";
    document.querySelector("#prodDivContainer #prodScrollToStart").style.display = "none";
    myPDCarousel?.current?.goTo(0);
    
  },[]);

 const productBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2 },
    { width: 850, itemsToShow: 3, itemsToScroll: 2 },
    { width: 1020, itemsToShow: 4, itemsToScroll: 3 },
    { width: 1450, itemsToShow: 5, itemsToScroll: 3 },
    { width: 1750, itemsToShow: 6, itemsToScroll: 3 }
  ];


  const setProductDivision = (item) => {
    props.setProductDivision(item)
    props.setSubRegion({})
    props.history.push("/dashboard/productdivision");
  }

  return (
    <div className={`${styles.productDivContainerWidth}`}>
    <div id="prodDivContainer" className={`${styles.pdProductsContainer}`} >
      {
        <div className={styles.scrollEndParent}>
          <div id="prodScrollToEnd" className={`${styles.leftPDArrow} ${styles.buttonStyle} `} onClick={() => onClickPDScrollToEnd()}>{"❮"}</div>
        </div>
      }
      {        
          <div className={ `${styles.pdLayout} ${styles.outerGrid} `}>
            <Title value="Product Divisions​" count={data.productDivisions.length} />
            <Carousel ref={myPDCarousel}
              onChange={(currentItem, pageIndex) =>
                myPDCarouselChange(currentItem, pageIndex)}
              breakPoints={productBreakPoints}>
              {data.productDivisions.map((item, index) => {
                return (
                  <div className={styles.productBoxPDs}>
                  <Product
                    key={index}
                    product={item}
                    {...props}
                    type="productdivision"
                    showDetail={setProductDivision}
                  />
                  </div>
                );
              })}
            </Carousel>
          </div>
      }
      {
        <div className={styles.scrollStartParent}>
          <div id="prodScrollToStart" className={`${styles.rightPDArrow} ${styles.buttonStyle} `} onClick={() => onClickPDScrollToStart()}>{"❯"}</div>
        </div>
      }

    </div>
    </div>
  )

}
export default ProdDivDashboard;
